<template>
  <div>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="modalSpinner"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title class="text-center">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner
      ></md-dialog-title>
    </md-dialog>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title class="text-center">Secure ID Verification</md-dialog-title>
      <md-dialog-content>
        <h6 class="text-center">We use SecureIDVerify to verify your identity.</h6>
        <ul class="just-content-center">
          <li>SecureIDverify is a trusted ID verification company</li>
          <li>
            Your ID document is used for verification purposes by SecureIDverify, and will
            not be seen by, stored on or processed by {{ Session.siteName }}
          </li>
          <li>The process is fast and simple</li>
        </ul>
        <md-dialog-actions>
          <md-progress-spinner
            v-if="showspinner"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <md-button
            v-if="!showspinner"
            class="md-raised md-primary btn-element"
            @click="go_modal2()"
            >Get Started</md-button
          >
        </md-dialog-actions>
        <div>
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showErrorDialog"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title class="text-center">Can not find Session!!!</md-dialog-title>
      <md-dialog-content>
        <h6 class="text-center">Please confirm session</h6>
        <ul class="just-content-center"></ul>
        <md-dialog-actions>
          <md-button class="md-raised md-primary btn-element" @click="Close()"
            >Close</md-button
          >
        </md-dialog-actions>
        <div>
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "VerifyGetStarted",

  data: () => ({
    modalSpinner: true,
    showDialog: false,
    showspinner: false,
    showErrorDialog: false,
    data_json: {
      apiKey: "abc123",
      clientReference: "1",
    },
    URL: "",
    session_key: "",
    modal: "",
    Session: {},
  }),

  methods: {
    go_modal2() {
      this.showspinner = true;
      axios
        .put("/api/session/" + this.session_key, {
          status: "started",
        })
        .then((response) => {
          this.showspinner = false;
          this.$router.push({
            name: "VerifyIDType",
            params: {
              session_key: this.session_key,
              modal: this.modal,
              Session: response.data,
            },
          });
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({
            name: "HandleError",
            params: {
              session: this.Session,
              type: "",
              modal: this.modal,
            },
          });
        });
    },
    Close() {
      this.showErrorDialog = false;
    },
    Alreadytaken() {
      this.$router.push({ name: "ExistSIDV" });
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  async mounted() {
    this.session_key = this.$route.query.id;
    this.modal = this.$route.query.modal;
    await axios
      .get("/api/session/" + this.session_key)
      .then((response) => {
        console.log(response);
        this.Session = response.data;
        this.showDialog = true;
      })
      .catch((error) => {
        console.log(error);
        this.$router.push({
          name: "HandleError",
          params: {
            modal: this.modal,
            session: this.Session,
            type: "notSession",
          },
        });
      });
  },
};
</script> 

<style lang="scss" scoped>
.logo-size {
  width: 150px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 100px;
  padding-right: 100px;
  color: white !important;
}
.md-dialog-actions {
  justify-content: center;
}

.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}
ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
li{
  margin-bottom:4px ;
}
.md-dialog-modal-none {
  right: unset;
  bottom: unset;
  z-index: 1;
  ::v-deep .md-dialog-container {
    box-shadow: none;
    max-width: 100%;
  }
}

.md-dialog-modal {
  z-index: 1;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>